import * as pdfjs from 'pdfjs-dist';
// Bundle the worker alongside the main thread script; Vite will hash it into the build.
import PdfWorker from 'pdfjs-dist/build/pdf.worker.mjs?worker';

pdfjs.GlobalWorkerOptions.workerPort = new PdfWorker();

export async function detectPdfLinks(file: File): Promise<boolean> {
  const buffer = await file.arrayBuffer();
  const doc = await pdfjs.getDocument({ data: buffer }).promise;
  try {
    for (let pageNum = 1; pageNum <= doc.numPages; pageNum++) {
      const page = await doc.getPage(pageNum);
      const annotations = await page.getAnnotations();
      const hasLink = annotations.some(
        (annotation: { subtype?: string; url?: string }) =>
          annotation.subtype === 'Link' && Boolean(annotation.url)
      );
      if (hasLink) return true;
    }
    return false;
  } finally {
    await doc.destroy();
  }
}
